import React, { Fragment, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  EditUserOrder,
  GetMyOrder,
  GetMySelectionOrder,
  GetStatusAdvncaedCount,
} from '../../../redux/user/user_order/user_order_services_sync';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import moment from 'moment';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import EmptyComponent from '../../../component/EmptyComponent';
import Select from 'react-select';
import {
  MyOrderSelection,
  SelectionOrderSelection,
} from '../../../utils/orderSelection';
import { updateOrderIndicator } from '../../../redux/user/user_order/user_order_slices';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import {
  updateCurrentRoom,
  updateSelectedRoom,
} from '../../../redux/user/room/roomSlice';
import { AppContext } from '../../../context/context';

const User_Orders = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { socket } = useContext(AppContext);

  const { profile } = useSelector((state) => state.user_profile);

  const { current_room } = useSelector((state) => state.room);

  const {
    my_order,
    orderPage,
    orderLimit,
    my_order_loader,
    orderIndicator,
    my_order_status,
    my_selection_order_status,
    get_advance_count_loader,
    get_advanced_order_count,
  } = useSelector((state) => state.user_order);

  useEffect(() => {
    dispatch(GetStatusAdvncaedCount());

    dispatch(
      GetMyOrder({
        status: my_order_status,
        page: orderPage,
        limit: orderLimit,
      })
    );
  }, []);

  const handleChange = (selectedOption, item) => {
    dispatch(updateOrderIndicator(item?._id));

    dispatch(
      EditUserOrder({ orderId: item?._id, status: selectedOption.target.value })
    );
  };

  const handlePageChange = (page) => {
    dispatch(
      GetMyOrder({ status: my_order_status, page: page, limit: orderLimit })
    );
  };

  const handleChangeSelectionState = (selectedOption) => {
    dispatch(
      GetMySelectionOrder({
        status: selectedOption?.value,
        page: orderPage,
        limit: orderLimit,
        my_selection_order: selectedOption,
      })
    );
  };

  const JoinRoom = async (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    await navigate('/user_dashboard/chat');

    socket.emit('join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  return (
    <>
      {get_advance_count_loader ? (
        <SingleTableLoader itemArray={[1, 2, 3, 4, 5]} />
      ) : (
        <div class="row">
          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 class="card-title mb-2">Delivered Order</h4>
                    <p class="text-muted fw-medium fs-22 mb-0">
                      {get_advanced_order_count?.completed}
                    </p>
                  </div>
                  <div>
                    <div class="avatar-md bg-primary bg-opacity-10 rounded">
                      <iconify-icon
                        icon="solar:cart-cross-broken"
                        class="fs-32 text-primary avatar-title"
                      ></iconify-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 class="card-title mb-2">Shipping Order</h4>
                    <p class="text-muted fw-medium fs-22 mb-0">
                      {get_advanced_order_count?.shipping}
                    </p>
                  </div>
                  <div>
                    <div class="avatar-md bg-primary bg-opacity-10 rounded">
                      <iconify-icon
                        icon="solar:box-broken"
                        class="fs-32 text-primary avatar-title"
                      ></iconify-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 class="card-title mb-2">Cancelled Order</h4>
                    <p class="text-muted fw-medium fs-22 mb-0">
                      {get_advanced_order_count?.cancelled}
                    </p>
                  </div>
                  <div>
                    <div class="avatar-md bg-primary bg-opacity-10 rounded">
                      <iconify-icon
                        icon="solar:tram-broken"
                        class="fs-32 text-primary avatar-title"
                      ></iconify-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 class="card-title mb-2">Processing Order</h4>
                    <p class="text-muted fw-medium fs-22 mb-0">
                      {get_advanced_order_count?.processing}
                    </p>
                  </div>
                  <div>
                    <div class="avatar-md bg-primary bg-opacity-10 rounded">
                      <iconify-icon
                        icon="solar:clock-circle-broken"
                        class="fs-32 text-primary avatar-title"
                      ></iconify-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 class="card-title mb-2">Pending Order</h4>
                    <p class="text-muted fw-medium fs-22 mb-0">
                      {get_advanced_order_count?.pending}
                    </p>
                  </div>
                  <div>
                    <div class="avatar-md bg-primary bg-opacity-10 rounded">
                      <iconify-icon
                        icon="solar:inbox-line-broken"
                        class="fs-32 text-primary avatar-title"
                      ></iconify-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="d-flex card-header justify-content-between align-items-center">
              <div>
                <h4 class="card-title">All Order List</h4>
              </div>

              <div style={{ minWidth: '10rem' }}>
                <Select
                  defaultValue={my_selection_order_status}
                  onChange={handleChangeSelectionState}
                  options={SelectionOrderSelection}
                />
              </div>
            </div>
            <div class="card-body p-0">
              {my_order_loader ? (
                <TableLoader
                  headerArray={[
                    'Order ID',
                    'Created at',
                    'Customer',
                    'Total',
                    'Payment Status',
                    'Items',
                    'Order Status',
                    'Order Selection',
                    'Action',
                  ]}
                  itemArray={[1, 2, 3, 4, 5, 6, 7, 8, 9]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th>Order ID</th>
                        <th>Created at</th>
                        <th>Customer</th>
                        <th>Total</th>
                        <th>Payment Status</th>
                        <th>Items</th>
                        <th>Order Status</th>
                        <th>Order Selection</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {my_order?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        my_order?.docs?.map((item, key) => (
                          <Fragment key={key}>
                            {item?._id !== orderIndicator ? (
                              <tr>
                                <td>#{item?._id?.slice(0, 10)}...</td>
                                <td>
                                  {moment(item?.createdAt).format(
                                    'MMM, DD YYYY'
                                  )}
                                </td>
                                <td>
                                  <a href="#!" class="link-primary fw-medium">
                                    {item?.name}
                                  </a>
                                </td>
                                <td>
                                  <CurrencyFormatter
                                    value={item?.totalPrice}
                                    currency={item?.symbol}
                                  />
                                </td>
                                <td>
                                  <span
                                    class={`badge ${
                                      item?.payment_status === 'paid'
                                        ? 'bg-success text-light'
                                        : 'bg-light text-dark'
                                    } px-2 py-1 fs-13 capitalize`}
                                  >
                                    {item?.payment_status}
                                  </span>
                                </td>
                                <td> {item?.total_quantity}</td>
                                <td>
                                  <span
                                    class={`badge border ${
                                      item?.status === 'pending'
                                        ? 'border-secondary text-secondary'
                                        : item?.status === 'processing'
                                        ? 'border-warning text-warning'
                                        : item?.status === 'cancelled'
                                        ? 'border-danger text-danger'
                                        : 'border-success text-success'
                                    } px-2 py-1 fs-13 capitalize`}
                                  >
                                    {item?.status}
                                  </span>
                                </td>
                                <td>
                                  <select
                                    onChange={(e) => {
                                      handleChange(e, item);
                                    }}
                                  >
                                    <option>Select Status</option>
                                    {MyOrderSelection?.map((item, key) => (
                                      <option value={item?.value}>
                                        {item?.label}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <NavLink
                                      to={`/user_dashboard/view_order/${item?.name}@${item?._id}`}
                                    >
                                      <a class="btn btn-light btn-sm">
                                        <iconify-icon
                                          icon="solar:eye-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>
                                    </NavLink>

                                    <a
                                      onClick={() => {
                                        const payload = {
                                          ...item,
                                          room: `${item?._id}-${item?.createdBy}-admin`,
                                        };

                                        JoinRoom(payload, current_room);
                                      }}
                                      class="btn btn-light btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:chat-round-bold-duotone"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <SingleTableLoader
                                itemArray={[1, 2, 3, 4, 5, 6, 7, 8, 9]}
                              />
                            )}
                          </Fragment>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={my_order?.page}
                  totalItems={my_order?.totalDocs}
                  pageSize={orderLimit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default User_Orders;
